import gql from 'graphql-tag';

const getTemplateTypesQuery = gql`
query getTemplateTypes {
  getTemplateTypes {
      type
      label
      description
    }
}
`;

const getTemplateTypes = () => ({
  query: getTemplateTypesQuery,
  module: 'splash',
  buildVariables: () => ({}),
  fetchPolicy: 'cache-first'
});

export default getTemplateTypes;